import React, { memo } from 'react'
import { ListItem, ListItemText } from 'transfix-ui/core'
import { ICarrierRelationshipInfoFragment } from '../../Carrier/graphql/CarrierRelationshipInfoFragment'

interface ICarrierRelationshipListItemProps {
  title: string
  carrierRelationship: ICarrierRelationshipInfoFragment
}

export const CarrierRelationshipListItem = memo<ICarrierRelationshipListItemProps>(
  ({ carrierRelationship, title }) => {
    const { user } = carrierRelationship
    const { fullName } = user

    return (
      <ListItem disableGutters>
        <ListItemText
          primary={title}
          secondary={fullName}
          primaryTypographyProps={{ color: 'textSecondary', variant: 'body2' }}
          secondaryTypographyProps={{ color: 'textPrimary', variant: 'body2' }}
        />
      </ListItem>
    )
  }
)

export default CarrierRelationshipListItem
